
import RcDomainMap from "../../../common/RcDomainMap.js";
import AiPrompt from './AiPrompt.js';
import AiPromptUtils from "./AiPromptUtils.js";

export default class AiPromptMap extends RcDomainMap {
  static MODEL_NAME = "AiPromptMap";

  constructor(domain, data) {
    super(domain, data, "AiPromptMap");
  }

  getAiPrompt(key) {
    var value = super.get(key);
    if (value) {
      return new AiPrompt(this.domain, value);
    }
    return new AiPrompt(this.domain);
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAiPrompt(key);
      values.push(item);
    }
    return values;
  }

  copy() {
    var data = this._copy();
    return new AiPromptMap(this.domain, data);
  }

  sortByCreatedDate() {
    var list = this.list();
    return list.sort(AiPromptUtils.SortByCreatedDate);
  }

  sort() {
    return this.sortByName();
  }

  sortByName() {
    var list = this.list();
    return list.sort(AiPromptUtils.SortByName);
  }

  find() {
    var keys = this.keys();
    var found = new AiPromptMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.prompt().findById(key);
      var item = new AiPrompt(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  findByIds(ids = []) {
    const values = new AiPromptMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAiPrompt(key);
      if (ids.includes(item.id())) {
        values.push(item);
      }
    }
    return values;
  }

  pointers() {
    const values = new AiPromptMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAiPrompt(key);
      values.push(item.pointer());
    }
    return values;
  }
}